import React, { useState } from "react";

const GSTCalculator = () => {
  const [total, setTotal] = useState("");
  const [base, setBase] = useState("");
  const [gst, setGst] = useState(18);
  const [incentive, setIncentive] = useState("");
  const [lastEdited, setLastEdited] = useState(null);

  const isValidInput = (val) => /^\d*\.?\d*$/.test(val);

  const calculate = (field, value) => {
    setLastEdited(field);

    if (!isValidInput(value)) return;

    // update field
    if (field === "total") setTotal(value);
    if (field === "base") setBase(value);
    if (field === "gst") setGst(value);

    // parse numbers safely
    const t = parseFloat(field === "total" ? value : total);
    const b = parseFloat(field === "base" ? value : base);
    const g = parseFloat(field === "gst" ? value : gst);

    // only calculate when gst is valid
    if (isNaN(g)) return;

    let newBase = b;
    let newTotal = t;

    if (field === "total" && !isNaN(t)) {
      newBase = t / (1 + g / 100);
      setBase(newBase.toFixed(2));
    }

    if (field === "base" && !isNaN(b)) {
      newTotal = b * (1 + g / 100);
      setTotal(newTotal.toFixed(2));
    }

    if (field === "gst") {
      if (!isNaN(t)) {
        newBase = t / (1 + g / 100);
        setBase(newBase.toFixed(2));
      } else if (!isNaN(b)) {
        newTotal = b * (1 + g / 100);
        setTotal(newTotal.toFixed(2));
      }
    }

    // incentive (based on base)
    const baseNum = !isNaN(newBase) ? newBase : parseFloat(base);
    if (!isNaN(baseNum)) {
      const inc = baseNum * 0.0025;
      setIncentive(inc.toFixed(2));
    }
  };

  return (
    <div className="card p-3">
      <h4>GST Calculator</h4>

      {/* Total */}
      <div className="row row-deck">
        <div className="col mb-3">
          <div>
            <label>Amount Recived (Incl. GST)</label>
            <input
              type="text"
              className="form-control"
              value={total}
              onChange={(e) => calculate("total", e.target.value)}
            />
          </div>
        </div>

        <div className="col mb-3">
          <div>
            <label>GST %</label>
            <input
              type="text"
              className="form-control"
              value={gst}
              onChange={(e) => calculate("gst", e.target.value)}
            />
          </div>
        </div>

        {/* Pre GST */}
        <div className="col mb-3">
          <div>
            <label>Pre-GST Amount</label>
            <input
              type="text"
              className="form-control"
              value={base}
              onChange={(e) => calculate("base", e.target.value)}
            />
          </div>
        </div>

        {/* GST */}

        {/* Incentive */}
        <div className="col mb-3">
          <div>
            <label>Incentive (0.25%)</label>
            <input
              type="text"
              className="form-control"
              value={incentive}
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GSTCalculator;
